import {InitPageStrict} from "../index";
import LiveClock from "../controls/live_clock";
import ScreenSaver from "../controls/screen_saver";

declare var App: any;
declare var storeLocation: string;

class ExitAlertsView {
  missingAlertChannel: any;
  exitAlertSettingId: any;
  missingAlertSound: any;
  latestExitAlertId: Number;

  constructor() {
    this.exitAlertSettingId = $("#exit_alert_setting_id").val();
    const exitAlertSettingSoundUrl = $("#exit_alert_setting_sound_url").val().toString();
    if(exitAlertSettingSoundUrl) this.missingAlertSound = new Audio(exitAlertSettingSoundUrl);

    this.missingAlertChannel = App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "ExitAlertChannel",
        tenant_code: storeLocation,
        exit_alert_setting_id: this.exitAlertSettingId
      },
      // Pass in connection callbacks
      {
        connected() { /* Called when the subscription is ready for use on the server */ },
        disconnected() { /* Called when the subscription has been terminated by the server */ },
        received: (data: any) => this.onNewMissingAlert(data)
      }
    );

    // The monitor hangs in the store, so its clock reads the store's time
    // rather than the viewing machine's.
    new LiveClock($("#exit_alert_store_time_zone").val()?.toString());
    new ScreenSaver();

    $(".latest_missing_alert").on("click", () => {
      if(!this.latestExitAlertId) return;

      this.openReasonsModal(this.latestExitAlertId);
    });

    $(document).on("click", ".btn-reason", (e) => {
      const reasonId = e.currentTarget.dataset.exitAlertReasonId
      this.handelClickOnReason(reasonId);
    });

    $(document).on("change", "#select-all", (e) => {
      $(".row-checkbox").prop("checked", $(e.currentTarget).prop("checked"));
    });

    $(document).on("change", ".row-checkbox", () => {
      const rows = $(".row-checkbox");
      $("#select-all").prop("checked", rows.length > 0 && rows.filter(":checked").length === rows.length);
    });

    $(document).on("click", ".clickable-exit-alert", (e) => {
      if (!$(e.target).is(".row-checkbox") && !$(e.target).closest(".exit-alert-item-image").length) {
        const checkedIds = $(".row-checkbox:checked").map(function () {
          return $(this).val();
        }).get(); 
        const exitAlertIds = checkedIds.length > 0 ? checkedIds : [e.currentTarget.dataset.exitAlertId];
        const clickedExitAlertId = e.currentTarget.dataset.exitAlertId
        this.openReasonsModal(exitAlertIds, clickedExitAlertId);
      }
    });
  };

  onNewMissingAlert(data) {
    console.log('We received these data: ', data);

    if(data['action'] === 'instant-alert') {
      // We can optimize this section and put alert in the right order instead of updating entire table

      if(this.missingAlertSound) this.missingAlertSound.play();
      $(".latest_missing_alert").html(data['alert_in_html']);
      this.latestExitAlertId = data['exit_alert_id'];
    }

    if(data['action'] === 'resolved-alerts') {
      // We can optimize this section and remove resolved rows instead of updating entire table

      if(data['resolved_ids'].includes(this.latestExitAlertId))
        $(".latest_missing_alert").empty();
    }

    this.updateExitAlertsTable();
  }

  openReasonsModal(exitAlertId, clickedExitAlertId?) {
    $.ajax({
      dataType: 'jsonp',
      url: "view/reasons.js",
      data: {
        exit_alert_setting_id: this.exitAlertSettingId,
        exit_alert_ids: exitAlertId,
        clicked_exit_alert: clickedExitAlertId
      }
    });
  }

  handelClickOnReason(reasonId) {
    const selectedExitAlertId = $("#selected_exit_alert_id").val();
    if(!selectedExitAlertId) return;

    $.ajax({
      type: "PUT",
      url:  "exit_alerts/assign_reason",
      data: {
        exit_alert_setting_id: this.exitAlertSettingId,
        exit_alert_reason_id:  reasonId,
        exit_alert_id: selectedExitAlertId
      }
    }).then(() => {
      $("#assign_reason_modal").modal("hide");

      this.updateExitAlertsTable();

      if(selectedExitAlertId == this.latestExitAlertId)
        $(".latest_missing_alert").empty();
    });
  }

  updateExitAlertsTable() {
    $.ajax({
      dataType: 'jsonp',
      url: "view.js?limit=100"
    });
  }
}

export function LoadPage() {
  InitPageStrict("exit_alerts index", () => {
    const m = new ExitAlertsView();
  });
}
